import { render } from "./App.vue?vue&type=template&id=af9926ca"
const script = {}

import "./App.vue?vue&type=style&index=0&id=af9926ca&lang=css"
script.render = render

export default script